const LetterDetails = ({ rows = [] }) => {
  if (!rows.length) return null
  return (
    <div className="pdf-letter-block">
      {rows.map(([serial, label, value]) => (
        <p key={serial} className="pdf-letter-line">
          <span className="pdf-letter-label">{label}:</span>{" "}
          <span className="pdf-letter-value">{value}</span>
        </p>
      ))}
    </div>
  )
}

export default LetterDetails
